import { useTranslation } from "react-i18next";
import AddCommentIcon from "@mui/icons-material/AddComment";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import { colors } from "../../data/colors";
import { ChatConversation } from "./chatTypes";

export default function ConversationList({
  conversations,
  loading,
  activeCode,
  activeType,
  onSelect,
  onNewChat,
}: {
  conversations: ChatConversation[];
  loading: boolean;
  activeCode: number | undefined;
  activeType: string | undefined;
  onSelect: (conversation: ChatConversation) => void;
  onNewChat: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        borderRight: `1px solid ${colors.lightGrey2}`,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 12px",
          backgroundColor: colors.chatPanelBg,
        }}
      >
        <strong>{t("p.chat")}</strong>
        <AddCommentIcon
          className="noSelect"
          style={{ cursor: "pointer", color: colors.darkGrey }}
          onClick={onNewChat}
        />
      </div>
      <div style={{ flex: 1, overflowY: "auto" }}>
        {conversations.length === 0 && !loading && (
          <div style={{ padding: 16, color: colors.darkGrey, fontSize: 13 }}>
            {t("p.chatNoConversations")}
          </div>
        )}
        {[...conversations]
          .sort((a, b) => Number(b.online) - Number(a.online))
          .map((c) => {
            const isActive = c.code === activeCode && c.type === activeType;
            return (
              <div
                key={`${c.type}-${c.type === "roleBroadcast" ? c.groupId : c.code}`}
                onClick={() => onSelect(c)}
                className="noSelect"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 12px",
                  cursor: "pointer",
                  gap: 8,
                  backgroundColor: isActive ? colors.lightGrey : colors.white,
                  borderBottom: `1px solid ${colors.lightGrey}`,
                }}
              >
                {c.type === "roleBroadcast" ? (
                  <GroupsIcon style={{ color: colors.darkGrey }} />
                ) : (
                  <div style={{ position: "relative", display: "flex" }}>
                    <PersonIcon
                      style={{
                        color: c.online ? colors.green : colors.lightGrey,
                      }}
                    />
                  </div>
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: c.unreadCount > 0 ? "bold" : "normal",
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {c.type === "roleBroadcast"
                        ? `${t("p.chatSentToRole")} ${c.name}`
                        : c.name}
                    </span>
                    <span style={{ fontSize: 11, color: colors.darkGrey }}>
                      {new Date(c.lastMessageDate).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 12,
                      color: colors.darkGrey,
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 160,
                      }}
                    >
                      {c.type === "roleBroadcast"
                        ? `${c.readCount}/${c.recipientCount} ${t("p.chatSeen")}`
                        : c.lastMessage}
                    </span>
                    {c.unreadCount > 0 && (
                      <span
                        style={{
                          backgroundColor: colors.green,
                          color: colors.white,
                          borderRadius: 10,
                          padding: "0 6px",
                          fontSize: 11,
                        }}
                      >
                        {c.unreadCount}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
